import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

const styles = theme => ({
  borderZone: {
    borderWidth: 2,
    borderColor: "#DCDCDC",
    borderStyle: "dashed",
    borderRadius: 5,
    margin: theme.spacing.unit * 1,
    padding: theme.spacing.unit * 2,
    width : "100%"
  }
});

const BorderZone = props => {
  const { classes, title, children } = props;
  return (
    <div className={classes.borderZone}>
      <Typography gutterBottom variant="h4">
        {title}
      </Typography>
      {title && <Divider />}
      {children}
    </div>
  );
};

export default withStyles(styles)(BorderZone);



// WEBPACK FOOTER //
// ./src/components/border-zone/index.js